import { render, staticRenderFns } from "./pbi-dashboard-drd-projection.page.vue?vue&type=template&id=83b7e2f8"
import script from "./pbi-dashboard-drd-projection.page.vue?vue&type=script&lang=ts"
export * from "./pbi-dashboard-drd-projection.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports